import { Toaster } from "../../ui/toaster";
import { Toaster as Sonner } from "../../ui/sonner";
import { TooltipProvider } from "../../ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Route, Routes } from "react-router-dom";
import NotificationList from "./pages/NotificationList";
import Header from "../../components/Header";
import RightAside from "../../components/RightAside";
import "../../assets/css/Notification/style.css";
import React from "react";
import UserService from "../../services/UserService";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const Notification = () => {
  // No product-subscription gate here -- unlike Underwriting Engine/Model Drift
  // Monitoring/etc., notification-service isn't a subscribed product. Any user
  // already authenticated into platform-ui (enforced by <RenderOnAuthenticated>
  // in App.js) can use it.

  // Important: shadcn/Radix components render via portals into <body>.
  // If we scope theme tokens only to an inner wrapper, portal content won't inherit them.
  // So while Notification is mounted, apply a root class + dark mode on <html>,
  // matching UnderwritingEngineV2.tsx / PortfolioRiskConcentration.tsx's convention.
  React.useEffect(() => {
    const root = document.documentElement;
    const body = document.body;
    root.classList.add("notification-admin-root", "dark");
    body.style.backgroundColor = "hsl(218, 30%, 8%)";
    body.style.color = "hsl(30, 9%, 95%)";
    body.style.margin = "0";
    body.style.padding = "0";
    return () => {
      root.classList.remove("notification-admin-root", "dark");
      body.style.backgroundColor = "";
      body.style.color = "";
      body.style.margin = "";
      body.style.padding = "";
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <div
          className="notification-admin-theme dark min-h-screen flex flex-col"
          style={{
            backgroundColor: "hsl(218, 30%, 8%)",
            minHeight: "100vh",
            color: "hsl(30, 9%, 95%)",
          }}
        >
          <Header
            token={UserService.getToken()}
            isMarketplacePage={false}
            notificationsCount={0}
            refreshNotifications={() => {}}
            setIndustry={() => {}}
            setCompany={() => {}}
            leftNode={null}
            productLabel="Notification"
            fixed={true}
          />

          {/* No StepsNavigation/Footer -- this module is a single screen today, not a
              wizard/multi-page flow like Underwriting Engine or Portfolio Risk
              Concentration. pt-24 accounts for the fixed Header alone (no sub-nav bar
              beneath it) -- re-check against the header's actual rendered height once
              this is running in a browser. */}
          <main className="flex-1 animate-fade-in pt-24 pb-16">
            <Routes>
              <Route path="/" element={<NotificationList />} />
            </Routes>
          </main>

          <RightAside showChildrenWhenNoPanel={false}>{null}</RightAside>
        </div>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default Notification;
